/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { ResyncResult } from "./ResyncResult";
import {
  ResyncResultFromJSON,
  ResyncResultFromJSONTyped,
  ResyncResultToJSON,
  ResyncResultToJSONTyped,
} from "./ResyncResult";

/**
 *
 * @export
 * @interface ResyncResponse
 */
export interface ResyncResponse {
  /**
   *
   * @type {Array<ResyncResult>}
   * @memberof ResyncResponse
   */
  results: Array<ResyncResult>;
}

/**
 * Check if a given object implements the ResyncResponse interface.
 */
export function instanceOfResyncResponse(
  value: object,
): value is ResyncResponse {
  if (!("results" in value) || value["results"] === undefined) return false;
  return true;
}

export function ResyncResponseFromJSON(json: any): ResyncResponse {
  return ResyncResponseFromJSONTyped(json, false);
}

export function ResyncResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ResyncResponse {
  if (json == null) {
    return json;
  }
  return {
    results: (json["results"] as Array<any>).map(ResyncResultFromJSON),
  };
}

export function ResyncResponseToJSON(json: any): ResyncResponse {
  return ResyncResponseToJSONTyped(json, false);
}

export function ResyncResponseToJSONTyped(
  value?: ResyncResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    results: (value["results"] as Array<any>).map(ResyncResultToJSON),
  };
}
